import styled, { css } from 'styled-components';
import { Paper } from '../Paper/PaperStyles';

import { StageProps } from './ModalTypes';

export const widthMap = {
  ss: '360px',
  xs: '548px',
  sm: '600px',
  md: '900px',
  lg: '1200px',
};

export const Stage = styled.div<StageProps>`
  max-width: ${({ width = 'md' }) => widthMap[width]};
  z-index: 1;

  ${({ fixedMaxWidth, width = 'md' }) =>
    fixedMaxWidth &&
    css`
      width: ${widthMap[width]};
    `}

  transform-origin:  bottom right;
  transition-delay: 0.2s;
  transition: all 0.2s cubic-bezier(0.65, 0, 0.35, 1);
  transform: scale(0.5, 0.5);
  opacity: 0;

  &.animated {
    transform: scale(1, 1);
    opacity: 1;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  right: ${({ theme }) => theme.spacing.km6};
  top: ${({ theme }) => theme.spacing.km6};
  color: ${({ theme }) => theme.color.text.neutral.strong};
  cursor: pointer;
  z-index: 2;
`;

export const PaperCustom = styled(Paper)`
  position: relative;

  ${({ noMargin }) =>
    noMargin &&
    css`
      margin: 0;
    `}}
`;
